class window.MapDisplay
    self = undefined

    constructor: (map, capitals) ->
        self = this

        @map = map
        @capitals = capitals

        $('#map-size').change(() ->
            if $(this).val() is 's'
                self.map.setMapSizeSmall()
            else if $(this).val() is 'l'
                self.map.setMapSizeLarge()
        )

        $('#territory-color').change(() ->
            val = $(this).val()
            $('[data-territory]').parent().each(() ->
                $(this).removeClass((index, css) ->
                    (css.match(/(^|\s)tc-\S+/g) or []).join(' ')
                )
                $(this).addClass("tc-#{val}")
            )
        )

        $('#show-capitals').change(() ->
            val = $(this).val()

            $('[data-territory]').parent('.capital').removeClass('capital')

            if val > 0
                for t in self.capitals[val]
                    $("[data-territory=#{t.territory_id}]").parent().addClass('capital')
        )

        $('#colorblind-filter').change(() ->
            val = $(this).val()

            $('#map').css('filter', 'none')
            $('#map').css('-webkit-filter', 'none')

            if val? and val isnt 'none'
                $('#map').css('filter', "url(##{val})")
                $('#map').css('-webkit-filter', "url(##{val})")
        )

        $('#show-adjacencies').change(() ->
            val = $(this).val() is "true"

            self.map.setTerritoryAdjacenciesDrawn(val)
        )
